export default __webpack_public_path__ + "static/media/pantry2-before2-480w.2b5af88b.png";